import React from 'react';
import './LevelCalculationContent.css';

interface Metric {
    icon: string;
    label: string;
    value: string;
}

export interface LevelCalculationContentProps {
    readinessScore: 'LOW' | 'INTERMEDIATE' | 'HIGH';
    readinessLabel: string;
    metrics: Metric[];
    step: any;
}

export const LevelCalculationContent: React.FC<LevelCalculationContentProps> = ({
    readinessScore,
    readinessLabel,
    metrics
}) => {
    const getScorePosition = () => {
        switch (readinessScore) {
            case 'LOW':
                return '15%';
            case 'INTERMEDIATE':
                return '50%';
            case 'HIGH':
                return '85%';
            default:
                return '50%';
        }
    };

    return (
        <div className="level-calculation">
            <div className="level-calculation__score-section">
                <h3 className="level-calculation__score-title">Readiness score</h3>
                <div className="level-calculation__score-bar">
                    <div className="level-calculation__score-track">
                        <div className="level-calculation__score-labels">
                            <span>LOW</span>
                            <span>INTERMEDIATE</span>
                            <span>HIGH</span>
                        </div>
                        <div className="level-calculation__score-indicator" style={{ left: getScorePosition() }}>
                            <div className="level-calculation__score-bubble">{readinessLabel}</div>
                        </div>
                        <div className="level-calculation__score-gradient" />
                    </div>
                </div>
            </div>

            <div className="level-calculation__metrics">
                {metrics.map((metric, index) => (
                    <div key={index} className="level-calculation__metric">
                        <div className="level-calculation__metric-icon">
                            <img src={metric.icon} alt={metric.label} />
                        </div>
                        <div className="level-calculation__metric-content">
                            <div className="level-calculation__metric-label">{metric.label}</div>
                            <div className="level-calculation__metric-value">{metric.value}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
